<template>
  <div
    class="modal fade"
    id="exportLocationsModal"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>

          <h4 class="modal-title">
            <b>{{ lang.LEX000 }}</b>
          </h4>
        </div>
        <div class="modal-body">
          <div class="form-group fg-client-select" v-if="clientList.length > 1">
            <label
              for="locationExportClientSelect"
              class="col-md-2 control-label"
              >{{ lang.LEX005 }}</label
            >
            <div class="col-md-10">
              <select2
                class="form-control"
                id="locationExportClientSelect"
                v-model="selectedClient"
                :placeholder="lang.LEX005"
              >
                <option></option>
                <option
                  v-for="client in clientList"
                  :key="client.ClientGuid"
                  :value="client.ClientGuid"
                >
                  {{ client.ClientName }}
                </option>
              </select2>
            </div>
          </div>

          <div class="form-group">
            <!-- <p>
              {{lang.C0082}}:
              <b>{{nameOfSelectedClient}}</b>
            </p>-->

            <!-- <div class="col-md-8 col-md-offset-2" style="padding-bottom: 20px;">
                <select
                  id="selectExportFiletype"
                  class="form-control"
                  v-model="exportLocationsFileType"
                >
                  <option value="csv">{{lang.C0083}}</option>
                  <option value="xls">{{lang.C0084}}</option>
                  <option value="xlsx">{{lang.C0085}}</option>
                </select>
            </div>-->
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-raised btn-default"
            data-dismiss="modal"
          >
            {{ lang.LEX001 }}
          </button>
          <button
            type="button"
            class="btn btn-raised dialog-btn-primary"
            @click="downloadExportData()"
          >
            {{ lang.LEX002 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "../Tools/Select2";

export default {
  name: "LocationExportModal",
  components: { Select2 },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedClient: "",
      clientList: [],
      exportLocationsFileType: "xlsx",
      lang: {
        LEX000: "Location Export",
        LEX001: "Cancel",
        LEX002: "Download",
        LEX003: "No client selected",
        LEX004: "Location export failed",
        LEX005: "Client",
      },
    };
  },
  watch: {
    showModal(newValue) {
      newValue ? this.openModal() : this.closeModal();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    this.globals.getClientList((data) => {
      this.clientList = data;
      if (this.clientList.length === 1) {
        this.$nextTick(() => {
          this.selectedClient = this.clientList[0].ClientGuid;
        });
      }
    });

    $("#exportLocationsModal").on("hidden.bs.modal", (e) => {
      this.$emit("modalClosed");
    });
  },
  methods: {
    openModal() {
      $("#exportLocationsModal").modal("show");
    },
    closeModal() {
      $("#exportLocationsModal").modal("hide");
    },
    downloadExportData() {
      if (!this.selectedClient) {
        this.globals.showErrorSnackbar(this.lang.LEX003);
        return;
      }

      let url = `api/Locations/Export/${this.selectedClient}?file_type=${this.exportLocationsFileType}`;
      $.ajax({
        method: "GET",
        url: url,
        success: (data) => {
          let guid = JSON.parse(data)[0].DownloadId;
          this.globals.downloadFile(guid);
          this.closeModal();
        },
        error: () => {
          console.error("Export data access failed in downloadExportData()");
          this.globals.showErrorSnackbar(this.lang.LEX004);
        },
      });
    },
  },
};
</script>

<style scoped>
.fg-client-select {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// LocationExportModal.vue?3a408f9c